import { Outlet } from 'react-router-dom';

import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useClickstream } from '@zenbusiness/application-commons-clickstream';
import { useCartContents } from '@zenbusiness/application-commons-ecommerce';
import useNetworkState from '@zenbusiness/application-commons-hooks/useNetworkState';
import { useIdentity } from '@zenbusiness/application-commons-identity';
import { usePriceList } from '@zenbusiness/application-commons-pricelist';
import PageLoading from '@zenbusiness/zui/PageLoading';

export default function ApplicationReadyGate({ children }) {
  const { ready: clickstreamIsReady } = useClickstream();
  const { ready: cartIsReady } = useCartContents();
  const { loading: priceListIsLoading } = usePriceList();
  const { loading: identityIsLoading } = useIdentity();
  const { loading: businessIsLoading } = useBusinessEntity();
  const { isOnline } = useNetworkState();

  // prettier-ignore
  const providersReady = (
    clickstreamIsReady
    && !priceListIsLoading
    && cartIsReady
    && !identityIsLoading
    && !businessIsLoading
    && isOnline
  );

  if (!providersReady) {
    return <PageLoading />;
  }

  return children || <Outlet />;
}
